var $0c1ee0b8d50940d9$exports = {};
$0c1ee0b8d50940d9$exports = {
  "Clear search": "Keres\xE9s t\xF6rl\xE9se"
};
export { $0c1ee0b8d50940d9$exports as default };